import { useCallback } from "react";
import { gql, useMutation } from "@apollo/client";

const LeaveTeacherCoordinatorReviewMutation = gql`
  mutation leaveTeacherCoordinatorReview(
    $teacherId: String!
    $fluencyScore: Int!
    $presenceScore: Int!
    $clarityScore: Int!
  ) {
    leaveTeacherCoordinatorReview(
      teacherId: $teacherId
      fluencyScore: $fluencyScore
      presenceScore: $presenceScore
      clarityScore: $clarityScore
    ) {
      id
      teacherId
      reviewedAtUtc
    }
  }
`;

export type LeaveTeacherCoordinatorReviewInput = {
  teacherId: string;
  fluencyScore: number;
  presenceScore: number;
  clarityScore: number;
};

export function useLeaveTeacherCoordinatorReview() {
  const [mutate, { loading }] = useMutation(
    LeaveTeacherCoordinatorReviewMutation,
  );

  const leaveReview = useCallback(
    async (input: LeaveTeacherCoordinatorReviewInput) => {
      await mutate({
        variables: {
          teacherId: input.teacherId,
          fluencyScore: input.fluencyScore,
          presenceScore: input.presenceScore,
          clarityScore: input.clarityScore,
        },
      });
    },
    [mutate],
  );

  return { leaveReview, loading };
}
